import axiosInstance from 'api/axiosInstance'

export const editProfileInfo = async (val: any, id: string) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: `/api/user/${id}`,
        data: val
    })
    return data
}
export const changeUsername = async (val: any) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: `/api/user/change-username`,
        data: val
    })
    return data
}
export const checkUsername = async (username: string) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/check-username',
        params: {
            username
        }
    })

    return data
}

export const toggleUserNameForwarding = async (val: boolean) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/user/update-username-forwarding',
        data: { forwarding: val }
    })
    return data
}

export const getLogginSessions = async () => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/device'
    })
    return data?.data
}

export const deleteLoginSession = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: `/api/user/device/${id}`
    })

    return data
}

export const deleteLoginSessions = async () => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: `/api/user/device/other`
    })
    return data
}

export type SecurityVerificationPurpose =
    | 'change_email'
    | 'change_password'
    | 'change_phone'
    | 'change_bank_details'
    | 'change_payout_method'

export const putEmail = async (payload: {
    email: string
    password: string
    verification_id: string
    recovery_email?: string
}) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/user/change-email',
        data: payload
    })

    return data
}

export const sendSecurityVerificationCode = async (
    purpose: SecurityVerificationPurpose,
    context: Record<string, unknown>
) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/security-verification/send',
        data: {
            purpose,
            context
        }
    })

    return data
}

export const verifySecurityVerificationCode = async (
    verificationId: string,
    code: string
) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/security-verification/verify',
        data: {
            verification_id: verificationId,
            code
        }
    })

    return data
}

export const putProfileSettings = async (
    setup: Record<string, boolean | string | null>
) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/user/profile-settings',
        data: setup
    })

    return data
}
export const editPassword = async (val: Record<string, string>) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/user/change-password',
        data: val
    })
    return data
}
/* -------------------------
Live Stream
-------------------------- */

export const putLiveStreamPrice = async (setup: Record<string, number>) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/user/live-stream-price',
        data: setup
    })
    return data
}

export const addLinkedAccount = async (setup: Record<string, string>) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/add-linked_account',
        data: setup
    })

    return data
}

export const confirmLinkedAccount = async (setup: Record<string, string>) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/confirm-linked_account',
        data: setup
    })

    return data
}

export const getLinkedAccounts = async () => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/linked_accounts'
    })

    return data?.data
}

export const changeLinkedAccount = async (setup: Record<string, string>) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/change-accounts',
        data: setup
    })

    return data
}
